import storage from '/src/utils/storage';
import { getTitleByView } from '../data/MemoViewTypes';

export function setClassifictionMode(bool){
    setMemoDataByKey("isClassified", bool)
}

export function addFavoriteMemo(memo_id){
    let favorites = getAllParameters()?.favorites;
    if (favorites == null){
        favorites = [];
    }
    favorites = [...favorites, memo_id];
    setMemoDataByKey("favorites",favorites)
}
export function removeFavoriteMemo(memo_id){
    let favorites = getAllParameters().favorites;
    favorites = favorites.filter(id => id !== memo_id);
    setMemoDataByKey("favorites", favorites)
}

export function isFavoriteMemo(memo_id) {
    return getAllParameters()?.favorites?.find(id => id === memo_id)
}

export function updateUserParameters(view, isOpen) {
    setMemoDataByKey(getTitleByView(view),isOpen)
}


export function getParameterByView(view){
    return getAllParameters() != null ? getAllParameters()[getTitleByView(view)] : null

}
function setUserParameters(memo_datas) {
    return storage('local').set('user_memo',memo_datas);
}

function setMemoDataByKey(key, value){
    let currentData = getAllParameters();
    if (currentData == null){
        currentData = { };
    }
    currentData[key] = value
    setUserParameters(currentData)
}
export function getAllParameters() {
    return storage('local').get('user_memo');
}